import React from 'react';
import { propOr } from 'ramda';
import { connect } from 'react-redux';
import { branch, renderComponent, compose } from 'recompose';

import { t } from '../../../../modules/infra/i18n';
import Spinner from '../../OverlaySpinner';

export default (accessor, noDataContent = t('common:loading_list.empty_message')) => compose(
  connect(
    state => ({
      isLoadingList: state.isLoadingList,
    }),
  ),
  branch(
    props => props.isLoadingList,
    renderComponent(Spinner),
  ),
  branch(
    props => !propOr(false, 'length', accessor(props)) && React.isValidElement(noDataContent),
    renderComponent(() => <div>{noDataContent}</div>),
  ),
  branch(
    props => !propOr(false, 'length', accessor(props)) && (typeof noDataContent === 'string'),
    renderComponent(() => <div className="c-heading c-heading--small u-mt">{noDataContent}</div>),
  ),
  branch(
    props => !propOr(false, 'length', accessor(props)),
    renderComponent(noDataContent),
  ),
);
